/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
module.exports = require('./lib/fetchr-plugin');



//////////////////
// WEBPACK FOOTER
// ./~/fluxible-plugin-fetchr/index.js
// module id = 324
// module chunks = 0